/* eslint-disable jira/filename-case */
import {
	performCmdbGetRequest,
	performCmdbPostRequest,
} from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import {
	getCmdbIconCreateUrl,
	getCmdbIconTokenFetchingUrl,
	getCmdbIconTokenUploadingUrl,
} from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbIconByIdUrl.tsx';
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import {
	performGetRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	InsightMediaAuthenticationUpload,
	InsightMediaAuthenticationFetch,
	IconType,
	MediaIconUploadResult,
	MediaBaseUrl,
	CollectionId,
	FileName,
	MediaJwt,
	MediaFileUuid,
	IconName,
	MediaClientId,
} from './ActionApi.types.tsx';

type MediaHeaders = {
	clientId: MediaClientId;
	mediaJwtToken: MediaJwt;
};

export const getMediaAuthHeaders = ({ clientId, mediaJwtToken }: MediaHeaders): HeadersInit => {
	return {
		'X-Client-Id': clientId,
		Authorization: `Bearer ${mediaJwtToken}`,
	};
};

export const mediaInfoForUpload = (
	workspaceId: WorkspaceId,
): Promise<InsightMediaAuthenticationUpload> =>
	performCmdbGetRequest(getCmdbIconTokenUploadingUrl(workspaceId));

type MediaUploadFile = {
	mediaBaseUrl: MediaBaseUrl;
	collectionId: CollectionId;
	fileName: FileName;
	blob: Blob;
} & MediaHeaders;

export const mediaUploadFile = ({
	mediaBaseUrl,
	collectionId,
	fileName,
	mediaJwtToken,
	blob,
	clientId,
}: MediaUploadFile): Promise<MediaIconUploadResult> =>
	performPostRequest(
		`${String(mediaBaseUrl)}/file/binary?collection=${String(collectionId)}&name=${String(
			fileName,
		)}&deletable=true`,
		{
			headers: {
				...getMediaAuthHeaders({ clientId, mediaJwtToken }),
				'Content-Type': blob.type,
			},
			body: blob,
		},
	);

export const mediaInfoForPulling = (
	workspaceId: WorkspaceId,
	fileUuid: MediaFileUuid,
): Promise<InsightMediaAuthenticationFetch> =>
	performCmdbGetRequest(getCmdbIconTokenFetchingUrl(workspaceId, fileUuid));

type MediaGetFileInfo = {
	mediaBaseUrl: MediaBaseUrl;
	mediaFileUuid: MediaFileUuid;
} & MediaHeaders;

export const mediaGetFileInfo = ({
	mediaBaseUrl,
	mediaFileUuid,
	mediaJwtToken,
	clientId,
}: MediaGetFileInfo): Promise<MediaIconUploadResult> =>
	performGetRequest(`${String(mediaBaseUrl)}/file/${String(mediaFileUuid)}`, {
		headers: getMediaAuthHeaders({ clientId, mediaJwtToken }),
	});

export const publishNewIcon = (
	workspaceId: WorkspaceId,
	iconName: IconName,
	mediaFileUuid: MediaFileUuid,
): Promise<IconType> =>
	performCmdbPostRequest(getCmdbIconCreateUrl(workspaceId), {
		body: JSON.stringify({
			name: iconName,
			mediaFileUuid,
		}),
	});
